import {Box} from "@mui/material";
import {getAnnounceFrom, getExtraTill} from "../campaignFormModel";
import {AudiencesSummary, Fields, formatMsk, Section} from "../../Summary/SummaryParts";

export default function SummaryStep(props) {
    const {currentCampaign: campaign, typeParameters} = props;
    const isPermanent = campaign.distributionType === 'permanent';

    return (
        <Box>
            <Section title="Basic">
                <Fields rows={[
                    ["ID:", campaign.campaignId],
                    ["Group:", campaign.groupId],
                    ["Priority:", campaign.priority],
                    ["Type:", campaign.offerType],
                    ["Bundle:", campaign.bundleId],
                    ["Tags:", campaign.tags],
                    campaign.matchmakingType ? ["Matchmaking:", campaign.matchmakingType] : null,
                    campaign.tournamentId != null ? ["Tournament ID:", campaign.tournamentId] : null,
                ]}/>
            </Section>

            <Section title="Distribution">
                <Fields rows={[
                    ["Type:", campaign.distributionType],
                    ["Hours:", campaign.durationHour !== "" ? campaign.durationHour : "-"],
                    ["Announce From:", formatMsk(getAnnounceFrom(campaign, typeParameters))],
                    ["From:", formatMsk(campaign.from)],
                    ["Till:", isPermanent ? 'Permanent' : formatMsk(campaign.till)],
                    ["Extra Time Till:", isPermanent ? '—' : formatMsk(getExtraTill(campaign, typeParameters))],
                ]}/>
            </Section>

            <Section title="Audiences">
                <AudiencesSummary audiences={campaign.audiences}/>
            </Section>

            {props.isTemplate &&
                <Section title="Template">
                    <Fields rows={[
                        ["Delay Days:", campaign.schedule.delayDays],
                        ["Till:", campaign.schedule.till != null ? formatMsk(campaign.schedule.till) : null],
                    ]}/>
                </Section>}
        </Box>
    );
}
